<template>
  <v-container
    fluid
    fill-height
  >
    <v-row
      v-if="isActive"
      justify="center"
      align="center"
      fill-width
    >
      <v-col
        xs12
        sm10
        md6
        lg4
      >
        <v-row>
          <v-col class="text-center">
            <img
              :src="require('@/assets/systemx_MAIN_Colour_Black.svg')"
              width="80%"
            >
          </v-col>
        </v-row>
        <v-card

          class="elevation-1 mb-16"
          width="500px"
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>Set Password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <validation-observer
              ref="passwordObserver"
            >
              <validation-provider
                v-slot="{ errors }"
                name="password"
                rules="required|password:@confirm|password-rule"
              >
                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  label="Password"
                  required
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                >
                  <template #label>
                    Password<span
                      class="red--text"
                    ><strong>* </strong></span>
                  </template>
                </v-text-field>
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="confirm"
                rules="required|password-rule"
              >
                <v-text-field
                  v-model="confirmation"
                  :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  label="Confirm Password"
                  required
                  :type="showConfirmPassword ? 'text' : 'password'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                >
                  <template #label>
                    Confirm Password<span
                      class="red--text"
                    ><strong>* </strong></span>
                  </template>
                </v-text-field>
              </validation-provider>
            </validation-observer>
          </v-card-text>
          <v-card-actions>
            <v-row class="px-3">
              <v-spacer />
              <v-col
                class="text-right"
              >
                <v-btn
                  color="success"
                  :disabled="isSbmBtnDisabled"
                  @click="submit"
                >
                  SUBMIT
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Snackbar ref="snackbar" />
  </v-container>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import { required } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} can not be empty',
});

extend('password-rule', {
  validate(value) {
    const regex = new RegExp(/(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/);
    return regex.test(value);
  },
  message: 'Use 8 or more characters with a mix of letters, numbers & symbols',
});

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Snackbar
  },

  beforeRouteEnter(to, from, next) {
    if (!to.query || !to.query.token || !to.query.environment) return;
    const token  = to.query.token;
    const environment = to.query.environment;
    next((method) => {
      method.init(token, environment);
    });
  },
  data: () => ({
    confirmation: '',
    password: '',
    token: '',
    showPassword: false,
    showConfirmPassword: false,
    isActive: false,
    isSbmBtnDisabled: false,
  }),
  created() {

  },
  mounted() {
    //this.checkResetPassword();
  },
  methods: {
    init(token, environment) {
      this.token = token;
      this.$api.setSxEnvironment(environment);
      this.checkResetPassword();
    },
    async submit() {
      const validate = await this.$refs.passwordObserver.validate();
      if (!validate) return;
      if (!this.token || !this.password) return;
      const submitModel = {
          token: this.token,
          password : this.password
      }
      const res = await this.$api.post(`workers/set-password`, submitModel);
      if (!res) {
        this.$refs.snackbar.showError();
        return;
      }

      this.$refs.snackbar.showSuccess('Password has been set successfully!');
      this.isSbmBtnDisabled = true;
      this.isActive = false;
      setTimeout(() => {
        window.location.href = 'https://www.systemx.net/';
      }, 3000);

    },

    async checkResetPassword() {
      if (!this.token) return;
      try
      {
        const res = await this.$api.get(`workers/password-check/${this.token}`);
        if(res.status !== 200 || res.data === false){

            this.$refs.snackbar.showError('Password Set has expired')
            return;
        }
        this.isActive = true;
      }catch (error) {
        console.log(error)
      }

    },
  },
};
</script>
